import { useEffect, useState } from "react";
import { ChromePicker, type ColorResult } from "react-color";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/view/components/ui/dialog";
import { Button } from "@/view/components/ui/button";

interface ColorPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value?: string;
  onChange: (hex?: string) => void;
  title?: string;
}

export const ColorPalette = ({
  open,
  onOpenChange,
  value,
  onChange,
  title = "Selecione a cor",
}: ColorPaletteProps) => {
  const [draftColor, setDraftColor] = useState(value);

  useEffect(() => {
    if (open) setDraftColor(value);
  }, [open, value]);

  const handlePickerChange = (color: ColorResult) => setDraftColor(color.hex);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm p-5" variant="center">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className=" w-full flex justify-center">

          <ChromePicker
           styles={{
            default: {
              picker: {
                width: "95%",
                boxShadow: "none",
                borderRadius: 0,
                background: "transparent",
                fontFamily: "inherit",
              },
              body: { padding: 0 },
              saturation: { borderRadius: 8 },
              controls: { padding: "12px 0 0" },
            },

          }} color={draftColor} onChange={handlePickerChange} />
        </div>

        <DialogFooter className="flex-col gap-2 sm:gap-0 sm:flex-row sm:items-center">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              onChange(undefined);
              onOpenChange(false);
            }}
          >
            Remover cor
          </Button>
          <Button
            type="button"
            className="text-white"
            onClick={() => {
              onChange(draftColor);
              onOpenChange(false);
            }}
          >
            Selecionar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};